var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whitespace-nowrap",attrs:{"href":'tel://' + _vm.number,"rel":"nofollow","target":"_blank"}},[_vm._v(_vm._s(_vm._f("phone")(_vm.number)))])
}
var staticRenderFns = []

export { render, staticRenderFns }